
$(document).on "click", ".copy_textarea", (event) ->
  event.currentTarget.select()

$(document).on "keydown", ".expanding_textarea", (event) ->
  App.Helpers.Inputs.resize_textarea(event.currentTarget)
